import {useDefault, useFirst} from '../../../common/common';
import {ReservationStayPreferences} from '../../model/reservation/stay-preferences/reservation-stay-preferences.model';
import {StayPreference} from '../../model/reservation/stay-preferences/stay-preference.model';
import { Preference } from '../../model/reservation/stay-preferences/preference.model';
import { PreferenceOption } from '../..//model/reservation/stay-preferences/preference-option.model';

const BOOLEAN_PREFERENCE_TYPE = 'BOOLEAN';
const LIST_PREFERENCE_TYPE = 'LIST';

export class ReservationStayPreferencesBuilder {
  private _model: ReservationStayPreferences;
  constructor() {
    this._model = new ReservationStayPreferences();
  }

  withStayPreferecesData(stayPreferencesInfo: any): ReservationStayPreferencesBuilder {

    const stayPreferencesData = useDefault(stayPreferencesInfo, {});

    this._setStayPreferences(useDefault(useFirst(stayPreferencesData.categories, {}).categories, []));
    this._model.editable = useDefault(stayPreferencesData.editable, null);
    this._model.optionsUnavailableMessage = useDefault(stayPreferencesData.optionsUnavailableMessage, null);
    this._model.footerMessage = useDefault(stayPreferencesData.footerMessage, null);
    this._model.notesMessage = useDefault(stayPreferencesData.notesMessage, null);
    this._model.saveMessage = useDefault(stayPreferencesData.saveMessage, null);
    this._model.saveToProfile = useDefault(stayPreferencesData.saveToProfile, null);
    this._model.userPreferenceSelected = useDefault(stayPreferencesData.userPrefSelected, false);

    return this;
  }

  private _setStayPreferences(categoriesData: Array<any>) {

    if (categoriesData.length > 0) {

      // for (const category of useDefault(categoriesData, [])) {
        categoriesData.forEach(category => {
           const stayPref = new StayPreference(category);
           const notes = new Array<string>();

           if (category.hasOwnProperty('notes') && category.notes !== undefined) {
            stayPref.notes.push(category.notes.toString());
           }
           useDefault(category.preferences, []).forEach(prefElement => {
              const pref = new Preference(prefElement);
             if (prefElement.hasOwnProperty('notes') ) {
                 stayPref.notes.push(prefElement.notes);
             }

             useDefault(prefElement.options, []).forEach(optionElement => {
                const opt = new PreferenceOption(optionElement);
                pref.options.push(optionElement);
              });

              stayPref.preferences.push(pref);
              stayPref.userPreferenceSelected = stayPref.userPreferenceSelected || useDefault(prefElement.userPrefSelected, false);
           });
          //  stayPref.notes = notes;
        this._model.stayPreferences.push(stayPref);
      // }
      });
    }
  }

  private _setStayPreferencesOptions(optionsData: Array<any>) {

  }

  build(): ReservationStayPreferences {
    return this._model;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/reservation-stay-preferences.builder.ts